export default "__VITE_ASSET__NPtVAiNW__"